export default __webpack_public_path__ + "static/samhsa-logo-2b0738b369a62696799d3327b1460194.png";